
export const eventTag = {
    LOYALTY_ACTIONS_TRACKING: 'loyaltyActionsTracking'
} as const;

export type TaggingEventName = typeof eventTag[keyof typeof eventTag];

type Nullable<T> = T | null;

export interface ILoyaltyEventData extends ILoyaltyViewPromotionEventData, ILoyaltySelectPromotionData {
    enh_action?: string;
    event_action: string;
    event_category?: string;
    event_label: string;
    event_name?: string;
}

export interface ILoyaltyViewPromotionEventData {
    promo_impression_list?: string[];
    promo_impression_message?: string[];
    promo_impression_name?: string[];
    promo_impression_offer_code?: string[];
    promo_impression_points?: string[];
    promo_impression_sku?: Nullable<string>[];
    promo_impression_status?: string[];
}

export interface ILoyaltySelectPromotionData {
    promo_creative?: string[];
    promo_id?: string[];
    promo_name?: string[];
    promo_pos?: string[];
}

interface EventPayloadMap {
    [eventTag.LOYALTY_ACTIONS_TRACKING]: ILoyaltyEventData;
}

export const emitAnalyticsEvent = <T extends TaggingEventName>(
    eventName: T,
    eventData: EventPayloadMap[T]
) => {
    window.dispatchEvent(new CustomEvent(eventName, { detail: eventData }));
};
